import BossModel from "@/models/BossModel";
import PlatinumTemplate from "@/models/PlatinumWidget/WidgetTemplate";

export default class AbstractWidget extends BossModel {

    /**
     *
     * @returns {*}
     * @constructor
     */
    WidgetTemplate() {
        return PlatinumTemplate.byModelName(this.constructor.model_name);
    }
}
